
import state from './moduleCampaignManagementState'
import mutations from './moduleCampaignManagementMutations'
import actions from './moduleCampaignManagementActions'
import getters from './moduleCampaignManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

